import React, { useEffect, useState } from "react";
import {
  Card,
  FormControl,
  MenuItem,
  Select,
  Chip,
  TextField,
  IconButton,
} from "@mhome/ui";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";
import CloseIcon from "@mui/icons-material/Close";

const PremadeFilter = ({
  sortBy,
  setSortBy,
  setFilterText,
  setShowFilter,
  onTagChange,
}) => {
  const getComponentBgColor = useComponentBackgroundColor();
  const [filterInput, setFilterInput] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [selectedTagsLocal, setSelectedTagsLocal] = useState(["all"]);
  const tags = ["all", "click", "send", "create"];

  useEffect(() => {
    setFilterText(filterInput);
  });

  const handleFilterInputChange = (event) => {
    setFilterInput(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setFilterValue(filterInput);
    }
  };

  const handleTagChange = (tag) => {
    if (tag === "all") {
      setSelectedTagsLocal(["all"]);
    } else {
      setSelectedTagsLocal((prev) => {
        const newTags = prev.filter((t) => t != "all");
        if (prev.includes(tag)) {
          const filtered = newTags.filter((t) => t !== tag);
          return filtered.length === 0 ? ["all"] : filtered;
        } else {
          return [...newTags, tag];
        }
      });
    }
  };

  return (
    <Card
      style={{
        marginBottom: "8px",
        backgroundColor: getComponentBgColor("hsl(var(--card))"),
      }}
      elevation={0}
    >
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          padding: "16px",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              flex: "1",
              marginRight: "16px",
              height: "100%",
            }}
          >
            <TextField
              fullWidth
              value={filterInput}
              onChange={handleFilterInputChange}
              onKeyDown={handleKeyDown}
              placeholder="fliter text"
              variant="outlined"
              size="small"
              InputProps={{
                style: {
                  backgroundColor: getComponentBgColor("hsl(var(--input))"),
                  borderRadius: "8px",
                },
              }}
              style={{
                height: "100%",
              }}
            />
          </div>

          <FormControl variant="outlined" style={{ width: "auto" }}>
            <Select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              size="small"
              style={{
                backgroundColor: getComponentBgColor("hsl(var(--input))"),
                paddingLeft: "16px",
                paddingRight: "16px",
              }}
            >
              <MenuItem value="popularity">Popularity</MenuItem>
              <MenuItem value="alphabet">Name (A-Z)</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          {tags.map((tag) => (
            <Chip
              key={tag}
              label={tag.charAt(0).toLowerCase() + tag.slice(1)}
              onClick={() => handleTagChange(tag)}
              style={{
                backgroundColor: selectedTagsLocal.includes(tag)
                  ? "hsl(var(--primary))"
                  : getComponentBgColor("hsl(var(--input))"),
                color: selectedTagsLocal.includes(tag)
                  ? "hsl(var(--primary-foreground))"
                  : "hsl(var(--foreground))",
                cursor: "pointer",
                transition: "background-color 0.3s",
                borderRadius: "16px",
                fontWeight: "normal",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  selectedTagsLocal.includes(tag)
                    ? "hsl(var(--primary))"
                    : "hsl(var(--accent))";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  selectedTagsLocal.includes(tag)
                    ? "hsl(var(--primary))"
                    : getComponentBgColor("hsl(var(--input))");
              }}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};

export default PremadeFilter;
